import EnhancedGrid from '@common/components/Grid'
import StudyCard from '../components/StudyCard'
import { useStudiesHomepage } from '@features/study_view/hooks/useStudiesHomepage'
import { ROW_PER_PAGE_OPTIONS } from '@common/constants/table'
import EmptyState from '@common/components/EmptyState/EmptyState'
import { Paper } from '@mui/material'
import SearchOffIcon from '@mui/icons-material/SearchOff'

interface CardViewProps {
  searchTerm: string
}

export default function CardView({ searchTerm }: CardViewProps) {
  const { studies, isLoading } = useStudiesHomepage(['studiesHomepage'], {
    limit: ROW_PER_PAGE_OPTIONS[2],
    next_cursor: null,
    previous_cursor: null,
    search: searchTerm,
  })

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (studies.length === 0) {
    return (
      <Paper sx={{ p: 3, borderRadius: 4 }}>
        <EmptyState
          title="No studies found"
          message={
            searchTerm ? `No studies match "${searchTerm}". Try a different search term.` : 'No studies available.'
          }
          icon={<SearchOffIcon sx={{ fontSize: 40, color: 'text.secondary' }} />}
        />
      </Paper>
    )
  }

  return <EnhancedGrid items={studies} renderItem={(study) => <StudyCard study={study} />} />
}
